import styled, { css } from 'styled-components';
import * as ScrollArea from '@radix-ui/react-scroll-area';

export const ScrollAreaRoot = styled(ScrollArea.Root)`
  width: 100%;
  overflow: hidden;
  position: relative;
`;

export const ScrollAreaViewport = styled(ScrollArea.Viewport)<{
  $orientacao: 'vertical' | 'horizontal';
}>`
  width: 100%;
  height: 100%;
`;

export const ScrollAreaScrollbar = styled(ScrollArea.Scrollbar)<{
  $orientacao: 'vertical' | 'horizontal';
}>`
  display: flex;
  ${({ theme, $orientacao }) => {
    if ($orientacao === 'vertical')
      return css`
        width: ${theme.spacing[2]}px;
      `;
    return css`
      height: ${theme.spacing[2]}px;
    `;
  }};

  ${({ theme }) => {
    return css`
      background: ${theme.colors.neutral.neutral_alpha[3]};
      padding: ${theme.radius[1]}px;
      border-radius: ${theme.radius[2]}px;
    `;
  }};
`;

export const ScrollAreaThumb = styled(ScrollArea.Thumb)`
  flex: 1;
  background: ${({ theme }) => theme.colors.neutral.neutral_alpha[8]};
  border-radius: 4px;
`;

export const ContainerConteudo = styled.div<{
  $orientacao: 'vertical' | 'horizontal';
  $espacamentoItens: number;
}>`
  display: flex;
  flex: 1;
  flex-direction: ${({ $orientacao }) =>
    $orientacao === 'vertical' ? 'column' : 'row'};
  ${({ $espacamentoItens }) => {
    return css`
      gap: ${$espacamentoItens}px;
    `;
  }}
`;
